var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCircleArrow01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 33"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  x: 0.5,
  y: 0.5,
  fill: "#fff",
  rx: 16
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 32,
  height: 32,
  x: 0.5,
  y: 0.5,
  stroke: "#E2E2E2",
  rx: 16
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m12.5 14.01 4 4 4-4 .99.99-4.99 4.99L11.51 15z",
  clipRule: "evenodd"
})));
export default SvgIconCircleArrow01;